import gql from "graphql-tag";

export const MAIL_DOCUMENT = gql`
	mutation MailDocument(
		$input: MailDocumentInput!
	) {
		mailDocument(input: $input) {
			boolean
		}
	}
`;
